import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SEO from '../components/SEO';
import LogoMark from '../components/LogoMark';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) { setError('Please enter your email and password.'); return; }
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API}/api/auth/login`, form);
      localStorage.setItem('knowfi_user', JSON.stringify({ name: res.data.name, email: res.data.email, plan: res.data.plan, token: res.data.token, createdAt: res.data.createdAt }));
      navigate('/account');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check your email and password.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.page}>
      <SEO title="Log In" description="Log in to your KnowFi account." path="/login" />
      <div style={styles.glow} />
      <div style={styles.card}>
        <LogoMark style={{ marginBottom: '24px' }} />
        <h1 style={styles.title}>Welcome back</h1>
        <p style={styles.subtitle}>Log in to your KnowFi account.</p>

        <form onSubmit={submit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input style={styles.input} type="email" placeholder="jane@example.com" value={form.email} onChange={e => set('email', e.target.value)} />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input style={styles.input} type="password" placeholder="Your password" value={form.password} onChange={e => set('password', e.target.value)} />
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" style={{ ...styles.btn, ...(loading ? styles.btnDisabled : {}) }} disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <p style={styles.signupLink}><Link to="/forgot-password" style={{ ...styles.linkBlue, fontSize: '13px' }}>Forgot your password?</Link></p>
        <p style={styles.signupLink}>Don't have an account? <Link to="/signup" style={styles.linkBlue}>Sign up free</Link></p>
      </div>
    </div>
  );
}

const styles = {
  page: { background: '#0f172a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', position: 'relative' },
  glow: { position: 'fixed', top: '0', left: '50%', transform: 'translateX(-50%)', width: '800px', height: '600px', background: 'radial-gradient(ellipse at center top, rgba(56,189,248,0.1) 0%, transparent 60%)', pointerEvents: 'none', zIndex: 0 },
  card: { background: '#1e293b', borderRadius: '20px', padding: '40px', width: '100%', maxWidth: '400px', border: '1px solid #334155', position: 'relative', zIndex: 1 },
  logo: { display: 'block', color: '#38bdf8', textDecoration: 'none', fontWeight: '800', fontSize: '20px', marginBottom: '24px' },
  title: { fontSize: '26px', fontWeight: '800', marginBottom: '8px', letterSpacing: '-0.3px' },
  subtitle: { color: '#64748b', fontSize: '15px', marginBottom: '28px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: '10px', color: '#f8fafc', padding: '12px 14px', fontSize: '15px', fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', width: '100%' },
  error: { background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '10px 14px', color: '#f87171', fontSize: '14px' },
  btn: { background: '#38bdf8', color: '#0f172a', border: 'none', padding: '14px', borderRadius: '10px', fontWeight: '700', fontSize: '16px', cursor: 'pointer', fontFamily: 'inherit', marginTop: '4px' },
  btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },
  signupLink: { textAlign: 'center', color: '#64748b', fontSize: '14px', marginTop: '20px' },
  linkBlue: { color: '#38bdf8', textDecoration: 'none', fontWeight: '600' },
};

export default Login;
